<div class="modal-header">
  <h4 class="modal-title">Upload SDWorx urenrapport</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="font-size: 14px; min-width: 960px;">
  <p>
    Upload het CSV-rapport <strong>"Overzicht prestaties en afwezigheden (uren)"</strong>.
    Je vindt dit in <strong>SDWorx Payroll → Rapporten</strong>.
  </p>
  <div class="alert alert-info" style="margin-bottom:8px;">
    Let op: Exporteer eerst naar <strong>CSV</strong>. XLS/XLSX wordt niet ondersteund in deze upload.
  </div>
  <div class="alert alert-info" style="margin-bottom:8px;">
    Belangrijk: het SDWorx <strong>XLS/CSV</strong>-rapport bevat enkel <strong>verwerkte periodes</strong>.
    Uren die nadien werden toegevoegd en nog niet door SDWorx via de loonberekening zijn verwerkt,
    verschijnen <strong>niet</strong> in het rapport.
  </div>
  <p style="color:#666;">Huidige maand: <strong>{{ selectedDateLabel }}</strong>. We updaten enkel de timesheets van deze maand.</p>

  <div style="margin: 12px 0;">
    <input type="file" accept=".csv" (change)="onFileSelected($event)" />
    <div *ngIf="fileName" style="font-size: 12px; color:#666; margin-top:4px;">Geselecteerd bestand: {{ fileName }}</div>
  </div>

  <!-- Column mapping (auto-detected, but adjustable) -->
  <div *ngIf="headers.length > 0" style="border-top:1px solid #eee; padding-top:12px; margin-top:12px;">
    <p style="margin:0 0 8px 0; font-weight:600;">Kolommen koppelen</p>
    <div style="display:grid; grid-template-columns: 200px 1fr; gap:10px; align-items:center; max-width:900px;">
      <label>Voornaam</label>
      <select [ngModel]="selectedFirstCol" (ngModelChange)="onHeaderMappingChanged('first', $event)">
        <option [ngValue]="-1">— niet gebruikt —</option>
        <option *ngFor="let h of headers; let i = index" [ngValue]="i">{{ h }}</option>
      </select>

      <label>Familienaam</label>
      <select [ngModel]="selectedLastCol" (ngModelChange)="onHeaderMappingChanged('last', $event)">
        <option [ngValue]="-1">— niet gebruikt —</option>
        <option *ngFor="let h of headers; let i = index" [ngValue]="i">{{ h }}</option>
      </select>

      <label>Naam (één kolom)</label>
      <select [ngModel]="selectedNameSingleCol" (ngModelChange)="onHeaderMappingChanged('name', $event)">
        <option [ngValue]="-1">— niet gebruikt —</option>
        <option *ngFor="let h of headers; let i = index" [ngValue]="i">{{ h }}</option>
      </select>

      <label>Totaal prestaties</label>
      <select [ngModel]="selectedHoursCol" (ngModelChange)="onHeaderMappingChanged('hours', $event)">
        <option [ngValue]="-1">— kies kolom —</option>
        <option *ngFor="let h of headers; let i = index" [ngValue]="i">{{ h }}</option>
      </select>
    </div>
    <small style="display:block; margin-top:6px; color:#666;">Tip: gebruik óf Voornaam+Familienaam, óf Naam (één kolom).</small>
  </div>

  <div *ngIf="isParsing">Bestand aan het verwerken…</div>

  <div *ngIf="parsed.length > 0" style="margin-top:14px;">
    <p style="margin: 8px 0; font-weight:600;">Gevonden rijen: {{ parsed.length }}.</p>

    <div *ngIf="unmatched.length > 0" class="alert alert-warning" style="margin-top: 8px;">
      Kon geen match vinden voor deze personen:
      <ul style="margin: 6px 0 0 16px;">
        <li *ngFor="let u of unmatched">{{ u.fullName || (u.firstName + ' ' + u.lastName) }} (uren: {{ u.hours }})</li>
      </ul>
    </div>

    <div *ngIf="matchedChanged.length > 0" style="margin-top: 8px;">
      <p style="font-weight: 600;">Wijzigingen (required hours):</p>
      <ul style="margin: 6px 0 0 16px;">
        <li *ngFor="let m of matchedChanged">
          {{ m.timesheet.employee?.firstName }} {{ m.timesheet.employee?.lastName }}:
          {{ m.originalHours || 0 }} → <strong>{{ m.newHours || 0 }}</strong>
        </li>
      </ul>
    </div>
    <div *ngIf="matchedChanged.length === 0" class="alert alert-info" style="margin-top:8px;">
      Geen wijzigingen gedetecteerd (waarden zijn identiek aan huidige required hours).
    </div>
    <div *ngIf="matchedUnchanged.length > 0" style="margin-top: 8px;">
      <p style="font-weight: 600;">Ongewijzigd:</p>
      <ul style="margin: 6px 0 0 16px;">
        <li *ngFor="let m of matchedUnchanged" style="color:#666;">
          {{ m.timesheet.employee?.firstName }} {{ m.timesheet.employee?.lastName }}: {{ m.newHours || 0 }} (reeds ingesteld)
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="button" (click)="activeModal.dismiss()">Annuleren</button>
  <button appGuardDoubleClick type="button" class="button button--primary" [disabled]="isParsing || !fileName" (click)="applyUpdates()">Toepassen</button>
  <small *ngIf="fileName && parsed.length === 0" style="margin-left:8px; color:#666;">Geen herkende rijen; toepassen rapporteert geen wijzigingen.</small>
</div>
